export const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay))
export const hasSession = () => {
    const sessions = Object.keys(sessionStorage)
    const localStorageSession = localStorage.getItem(localStorageLabel())
    if (localStorageSession !== null) {
        sessionStorage.setItem(sessionStorageLabel(localStorageSession), localStorageSession)
    }
    return sessions.length > 0 ? sessions.filter(e => e.startsWith('firebase:authUser')).length > 0 : false
}

export const localStorageLabel = () => {
   return `marketPlaceUserData:${window.location.host}`
}

export const sessionStorageLabel = (localStorageSession) => {
    const p = JSON.parse(localStorageSession)
    return `firebase:authUser:${p.apiKey}:${p.appName.split('-')[0]}`
}

